import React from "react";
import "@/Scss/Components/loader.scss"

const Loader = () => {
    return (
        <div className={`loader`}>
            <div className={`loader-spinner`}></div>
        </div>
    );
}

export default Loader;
